import axios from 'axios'

import {
  setupRequestInterceptor,
  setupResponseInterceptor,
} from '@/interceptors/api.interceptor'

export const apiClient = axios.create({
  baseURL:
    (import.meta.env.VITE_API_BASE_URL ||
      'https://jsonplaceholder.typicode.com') + '/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

setupRequestInterceptor(apiClient)
setupResponseInterceptor(apiClient)

export default apiClient
